import OSS from "ali-oss";
import dayjs from "dayjs";
import md5 from "js-md5";
import store from "@/store";
import { getFileSuffix } from "./file";

// 默认配置项
const defaultConfig = {
	accessKeyId: process.env.VUE_APP_OSS_ACCESS_KEY_ID,
	accessKeySecret: process.env.VUE_APP_OSS_ACCESS_KEY_SECRET,
	endpoint: "https://oss-cn-shenzhen.aliyuncs.com",
	secure: true
};

/**
 * @description 款式OSS Client(用于存储款式相关图片)
 */
const stylesClient = new OSS({
	...defaultConfig,
	host: process.env.VUE_APP_STYLES_OSS_HOST,
	bucket: "singbada-styles"
});

/**
 * @description 基础图片OSS Client(用于存储基础图片)
 */
const basicImagesClient = new OSS({
	...defaultConfig,
	host: process.env.VUE_APP_IMAGES_OSS_HOST,
	bucket: "singbada-images"
});

/**
 * @description 文件OSS Client(用于存储文件)
 */
const filesClient = new OSS({
	...defaultConfig,
	host: process.env.VUE_APP_FILES_OSS_HOST,
	bucket: "singbada-files"
});

const bucketTypeMap = {
	styles: "ab",
	images: "ac",
	files: "ag"
};

/**
 * @description 上传文件到OSS
 * @param {object} event 上传的文件
 * @param {string} bucketType bucket类型 styles: 款式图片, images: 基础图片, files: 文件
 * @param {object} options OSS配置
 */
export const uploadFileToOss = async (event, bucketType = "images", options = {}) => {
	try {
		let client = null;

		switch (bucketType) {
			case "styles":
				client = stylesClient;
				break;
			case "images":
				client = basicImagesClient;
				break;
			case "files":
				client = filesClient;
				break;
			default:
				client = basicImagesClient;
				break;
		}

		const currentDate = dayjs().format("YYYYMMDD");
		const fileSuffix = getFileSuffix(event.file.name);

		const userInfo = store.getters.userInfo || {};
		const random5Digits = Array.from({ length: 5 }, () => Math.floor(Math.random() * 10)).join("");
		const fileName = md5(Date.now().toString() + random5Digits + userInfo.pattern_room_id || "" + event.file.name);
		const file = event.file;
		const fileUrl = `${currentDate}/${fileName}.${fileSuffix}`;

		const result = await client.multipartUpload(`${bucketTypeMap[bucketType]}/${fileUrl}`, file, options);

		if (result.res.status === 200) {
			return result;
		}

		return Promise.reject(result);
	} catch (error) {
		return Promise.reject(error);
	}
};
